export const BuildingMenuType = {
    HOME: 'HOME',
    FLOOR: 'FLOOR',
    SEARCH: 'SEARCH',
    EVENT: 'EVENT',
    PARKING: 'PARKING',
    FACILITIES: 'FACILITY',
    FAQ: 'FAQ',
} as const;

export type BuildingMenuType = (typeof BuildingMenuType)[keyof typeof BuildingMenuType];
